import { SmsSender, SmsSenderStatus } from './types';

export type SmsSenderStats = {
  approved: number;
  inRegistration: number;
  rejected: number;
  drafts: number;
};

export const countSendersByStatus = (senders: SmsSender[]): SmsSenderStats =>
  senders.reduce<SmsSenderStats>(
    (acc, sender) => {
      switch (sender.status) {
        case 'APPROVED':
          acc.approved += 1;
          break;
        case 'IN_REGISTRATION':
          acc.inRegistration += 1;
          break;
        case 'REJECTED':
          acc.rejected += 1;
          break;
        case 'DRAFT':
          acc.drafts += 1;
          break;
      }
      return acc;
    },
    { approved: 0, inRegistration: 0, rejected: 0, drafts: 0 }
  );

export const formatSenderRegistrationDate = (value?: string) => {
  if (!value) {
    return '—';
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }

  return new Intl.DateTimeFormat(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(date);
};

export const getSenderStatusBadgeClass = (status: SmsSenderStatus) => {
  switch (status) {
    case 'APPROVED':
      return 'bg-emerald-100 text-emerald-700';
    case 'IN_REGISTRATION':
      return 'bg-blue-50 text-blue-700';
    case 'REJECTED':
      return 'bg-rose-100 text-rose-700';
    case 'DRAFT':
      return 'bg-slate-100 text-slate-600';
  }
};

export const getSenderStatValueClass = (status: SmsSenderStatus) => {
  switch (status) {
    case 'APPROVED':
      return 'text-emerald-600';
    case 'IN_REGISTRATION':
      return 'text-blue-600';
    case 'REJECTED':
      return 'text-rose-600';
    case 'DRAFT':
      return 'text-slate-700';
  }
};
